<template>
  <div class="w-full h-full">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới CV - list MA</h1>
      <div class="float-right">
        <button
          type="submit"
          class="font-medium px-3 f12 btn btn-primary m-r-10"
          @click="submitForm"
          :disabled="isLoading"
        >
          Lưu lại
        </button>
      </div>
      <hr />
    </div>
    <div class="card px-3">
      <b-card class="card-section border p-0" style="border: 1px solid #dddddd">
        <b-row class="gx-1 pt-15">
          <b-col cols="12" md="6" class="border-right" style="padding-left: 2rem">
            <h3 class="h3">Chọn nhanh, áp dụng cho toàn bộ MA</h3>
            <div class="form-item">
              <div class="form-label">Nhóm công việc</div>
              <div class="form-input">
                <Select2
                  v-model="headerFilter.type"
                  :options="typeOptions"
                  placeholder="Chọn nhóm công việc"
                  @change="loadHeaderPurposes"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Tên công việc</div>
              <div class="form-input">
                <Select2
                  v-model="headerFilter.purposes"
                  :options="headerFilterOptions.purposes"
                  placeholder="Chọn tên công việc"
                  :disabled="!headerFilter.type || !headerFilterOptions.purposes.length"
                />
                <!-- :placeholder="
                    headerFilterLoading.purposes ? 'Loading...' : 'Chọn tên công việc'
                  " -->
              </div>
            </div>

            <!-- <div class="form-group">
            <Select2
              v-model="headerFilter.applyFor"
              :options="subjectOptions"
              placeholder="Chọn đối tượng"
            />
          </div> -->

            <div class="form-item">
              <div class="form-label">Hình thức chăm sóc</div>
              <div class="form-input">
                <Select2
                  v-model="headerFilter.methodCare"
                  :options="methodCareOptions"
                  placeholder="Chọn hình thức chăm sóc"
                  :disabled="isLoading"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Thời gian dự kiến</div>
              <div class="form-input">
                <DateRangePicker
                  class="w-100"
                  :ranges="false"
                  v-model="headerFilter.dateRange"
                  :locale-data="Config.localeData"
                >
                  <template v-slot:input="picker">
                    <label
                      v-if="picker.startDate && picker.endDate"
                      style="min-width: 11.5em; margin-left: -5px !important"
                      class="text-center"
                    >
                      {{ picker.startDate | formatDate }} -
                      {{ picker.endDate | formatDate }}
                    </label>
                    <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                      Chọn thời gian dự kiến
                    </label>
                    <i
                      class="bx bx-calendar fonsize-20"
                      style="position: absolute; right: 1px; top: 50%; transform: translateY(-50%)"
                    ></i>
                  </template>
                </DateRangePicker>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Người xử lý</div>
              <div class="form-input">
                <Select2
                  v-model="headerFilter.assigneeId"
                  :options="dataStaff"
                  placeholder="Tìm kiếm/Chọn người xử lý"
                />
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">Lý do</div>
              <div class="form-input">
                <b-textarea v-model="headerFilter.note" placeholder="Lý do" />
              </div>
            </div>

            <div class="form-item">
              <div class="form-label">Mô tả</div>
              <div class="form-input">
                <b-textarea v-model="headerFilter.description" placeholder="Mô tả" />
              </div>
            </div>

            <!-- <div
          class="form-group"
          v-show="[EnumTaskApplyFor?.MO].includes(headerFilter.applyFor)"
        >
          <Select2
            v-model="headerFilter.merchantOwnerId"
            :disabled="!headerFilter.applyFor"
            :options="headerFilterOptions.merchantOwner"
            placeholder="Tìm kiếm merchant owner"
            :settings="merchantOwnerSettings"
            @change="onChangeMerchantOwner($event)"
          />
        </div> -->

            <!-- <div class="form-group">
            v-show="['STORE'].includes(headerFilter.applyFor)"
            <Select2
              v-model="headerFilter.storeId"
              :options="headerFilterOptions.store"
              :placeholder="
                headerFilterLoading.store ? 'Loading...' : 'Tìm kiếm cửa hàng'
              "
              :settings="headerStoreSettings"
            />
            @change="onChangeStore($event)"
          </div> -->

            <!-- <div class="form-group">
            <Select2
              v-model="headerFilter.assigneeId"
              :options="headerFilterOptions.staff"
              :placeholder="
                headerFilterLoading.staff ? 'Loading...' : 'Chọn người xử lý'
              "
              :disabled="disabledStaff || !isUpdateAndIsSuperior"
            />
          </div> -->

            <div class="form-group d-flex justify-content-end form-group-action mt-4">
              <button
                class="pt-2 mr-2 btn btn-outline-success f12"
                @click="assignAll"
                :disabled="isLoading"
              >
                Áp dụng toàn bộ
              </button>
              <button
                class="pt-2 btn btn-outline-danger f12"
                @click="removeItemsWithoutAssignee"
                :disabled="isLoading"
              >
                Xoá toàn bộ MC không có người xử lý
              </button>
              <!-- <button
              type="button"
              class="pt-2 mr-2 btn btn-primary hc-37"
              @click="assignSelected"
              :disabled="isLoading || !idsSelected.length"
            >
              Gán theo lựa chọn
            </button> -->
              <!-- <button
                type="button"
                class="pt-2 mr-2 btn btn-danger hc-37"
                @click="unassign"
                :disabled="isLoading"
              >
                Bỏ áp dụng toàn bộ
              </button>
              <button
                type="button"
                class="pt-2 mr-2 btn btn-info hc-37"
                @click="resetFilter"
                :disabled="isLoading"
              >
                Đặt lại lọc
              </button> -->
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-help">
              <h3>Hướng dẫn sử dụng</h3>

              <div>
                <label class="font-bold">Chọn nhanh, áp dụng cho toàn bộ MA </label>
                <ul>
                  <li>
                    Chọn các thông tin cần thiết trong phần "Chọn nhanh, áp dụng cho toàn bộ MA"
                  </li>
                  <li>
                    Nhóm công việc, Tên công việc, Hình thức chăm sóc* (mặc định là "Offline")
                  </li>
                  <li>
                    Sau khi điền đầy đủ thông tin, nhấn nút "Áp dụng toàn bộ" để áp dụng các thông
                    tin đã chọn cho tất cả MA trong danh sách.
                  </li>
                </ul>
                <label class="font-bold">Bảng dữ liệu </label>
                <ul>
                  <li>
                    Sau khi chọn áp dụng tất cả bạn có thể tuỳ chỉnh lại thông tin của từng merchant
                    sao cho phù hợp
                  </li>
                  <li>
                    Sau khi đã tuỳ chỉnh thông tin phù hợp nhấn lưu lại để tạo merchant hàng loạt
                  </li>
                </ul>

                <label class="font-bold"
                  >Chú ý <img class="mr-1 ml-1" src="@/assets/img/warning.svg" alt="warning-icon"
                /></label>
                <ul>
                  <li>Merchant để tạo công việc phải được chọn đầy đủ thông tin</li>
                  <li>
                    Nếu merchant không có người xử lý hãy chọn xoá toàn bọ MC không có người xử lý
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <div class="">
          <TableViewAddTak
            :items="dataTable"
            :loading="isLoading"
            :type-options="typeOptions"
            :method-care-options="methodCareOptions"
            :selected-ids="idsSelected"
            :max-select="maxtSelect"
            :config="Config"
            :current-page="pagination.page"
            :per-page="pagination.limit"
            @type-change="loadItemPurposes"
            @clear-select="onClearSelect"
            @remove-item="removeItem"
          />
          <!-- <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div> -->
        </div>
      </div>
    </div>
    <loading :active.sync="isLoadingSubmit" :is-full-page="true"> </loading>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  // import Config from '@/thirdParty/config'
  // import { CommonService } from '@/services/common.service'
  // import { SalesManagerService } from '@/services/sales-manager.service'
  import {
    Search,
    // GetIdsByCustomerIds
  } from '@/services/customer-support/account'
  // import { SearchByCode } from '@/services/customer-support/location'
  import { showMess } from '@/config/utils'
  import { List as ListStore } from '@/services/customer-support/store'
  import { GetAssignment } from '@/services/customer-support/store-staff'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import gzip from 'gzip-js'
  import {
    WorkGroupList,
    // WorkTaskList,
    TaskAddAll,
  } from '@/services/customer-support/task'
  import Config from '@/thirdParty/config'
  import TableViewAddTak from './components/TableViewAddTak.vue'
  import {
    EnumTaskStatus,
    EnumTaskApplyFor,
    TaskApplyFor,
    // FlowChangeStatus,
    EnumTaskMethodCare,
    TaskMethodCare,
  } from '@/constant/customerSupport'
  import { StaffService } from '@/services/staff.service'

  // const maxtSelect = 200
  const NEW_ID = 'new'

  export default {
    components: {
      TableViewAddTak,
      Loading,
    },

    data() {
      return {
        Config,
        EnumTaskApplyFor,
        EnumTaskStatus,
        applyFor: '',
        subjectOptions: TaskApplyFor,

        id: '',
        status: EnumTaskStatus.NEW,
        newStatus: EnumTaskStatus.NEW,

        type: '',
        typeOptions: [],

        ids: [], // Dùng để lưu danh sách ID được truyền qua URL

        purposes: '',
        isLoadingPurposes: false,
        purposesOptions: [],

        merchantOwnerId: '',
        merchantOwnerOptions: [],

        storeId: '',
        isLoadingStore: false,
        storeOptions: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),

        assigneeId: JSON.parse(localStorage.getItem('userData')).userId,
        isLoadingStaff: false,
        staffOptions: [
          {
            id: JSON.parse(localStorage.getItem('userData')).userId,
            text: JSON.parse(localStorage.getItem('userData')).name,
          },
        ],

        rowVariants: {},

        methodCare: EnumTaskMethodCare.OFFLINE,
        methodCareOptions: TaskMethodCare,

        // Các biến cho table
        isLoading: true,
        selectAll: false,
        totalCount: 0,
        // fields: [
        //   {
        //     key: 'index',
        //     label: 'STT',
        //     thStyle: 'width: 30px',
        //     tdClass: 'text-center'
        //   },
        //   {
        //     key: 'owner',
        //     label: 'Thông tin MA',
        //     sortable: false,
        //     thStyle: 'min-width: 150px, max-width: 200px',
        //     tdClass: 'td_class'
        //   },
        //   {
        //     key: 'type',
        //     label: 'Nhóm công việc/Công việc',
        //     sortable: false
        //   },

        //   // {
        //   //   key: 'purposes',
        //   //   label: 'Tên công việc',
        //   //   sortable: false
        //   // },

        //   // {
        //   //   key: 'applyFor',
        //   //   label: 'Đối tượng',
        //   //   sortable: false
        //   // },
        //   {
        //     key: 'methodCare',
        //     label: 'Người xử lý/Hình thức/Thời gian',
        //     sortable: false
        //   },
        //   {
        //     key: 'note',
        //     label: 'Lý do/Mô tả',
        //     sortable: false,
        //     thStyle: 'width: 300px'
        //   },
        //   // {
        //   //   key: 'storeId',
        //   //   label: 'Cửa hàng',
        //   //   sortable: false,
        //   //   thStyle: 'min-width: 80px'
        //   // },
        //   // {
        //   //   key: 'assigneeId',
        //   //   label: 'Người xử lý',
        //   //   sortable: false,
        //   //   thStyle: 'min-width: 150px, max-width: 200px',
        //   //   tdClass: 'td_class'
        //   // },
        //   {
        //     key: 'actions',
        //     label: 'Thao tác',
        //     thStyle: 'width: 80px',
        //     tdClass: 'text-center'
        //   }
        // ],

        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        dataTable: [],
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],

        // Multiple select
        idsSelected: [],
        maxtSelect: 200,

        // User data
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        // merchantOwnerSettings: {
        //   ajax: {
        //     transport: (params, success, failure) => {
        //       const txtSearch = params.data?.q?.trim() || ''
        //       if (!txtSearch) {
        //         return success({
        //           results: []
        //         })
        //       }

        //       // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
        //       if (this.tLoadMerchantOwner) {
        //         clearTimeout(this.tLoadMerchantOwner)
        //       }
        //       this.tLoadMerchantOwner = setTimeout(() => {
        //         Search({
        //           // showFields: ["id", "ownerName", "email"],
        //           limit: 10,
        //           page: 1,
        //           // queryString,
        //           keyWord: txtSearch,
        //           sort: {
        //             direction: 'ASC',
        //             properties: ['ownerName']
        //           }
        //         })
        //           .then((res) => {
        //             success({
        //               results:
        //                 res.data.list?.map((item) => {
        //                   return {
        //                     id: item.id,
        //                     text: item.ownerName || item.email
        //                   }
        //                 }) || []
        //             })
        //           })
        //           .catch(failure)
        //       }, 500)
        //     }
        //   }
        // },
        dataStaff: [],
        headerFilter: {
          type: '',
          purposes: '',
          applyFor: '',
          methodCare: EnumTaskMethodCare.OFFLINE,
          merchantOwnerId: '',
          note: '',
          description: '',
          storeId: '',
          dateRange: {
            startDate: null,
            endDate: null,
          },
          assigneeId: JSON.parse(localStorage.getItem('userData')).userId,
        },

        // State cho các options của header filter
        headerFilterOptions: {
          purposes: [],
          merchantOwner: [],
          store: [],
          staff: [
            {
              id: JSON.parse(localStorage.getItem('userData')).userId,
              text: JSON.parse(localStorage.getItem('userData')).name,
            },
          ],
        },

        // Loading states cho header filter
        headerFilterLoading: {
          purposes: false,
          store: false,
          staff: false,
        },
        query: '',
        deleteds: [],
        isLoadingSubmit: false,
        // searchStaff: {
        //   ajax: {
        //     delay: 500,
        //     transport: (params, success, failure) => {
        //       const txtSearch = params.data?.q?.trim() || ''
        //       if (!txtSearch) {
        //         return success({ results: [] })
        //       }
        //       const queryString = `{textSearch} like '''${txtSearch}'''`

        //       // if (this.selectedStoreList.length > 0) {
        //       //   const excludeIds = this.selectedStoreList
        //       //     .map((store) => `'''${store.id}'''`)
        //       //     .join(" , ");
        //       //   queryString += ` and {id} nin [${excludeIds}]`;
        //       // }

        //       if (this.tLoadStore) {
        //         clearTimeout(this.tLoadStore)
        //       }

        //       StaffService.getStaffByIdSuperior({
        //     userId: this.dataUser.userId
        //   })
        //       this.tLoadStore = setTimeout(() => {
        //         StaffService.getStaffByIdSuperior({
        //           userId: this.dataUser.userId,
        //           limit: 50,
        //           page: 1,
        //           queryString,
        //           sort: {
        //             direction: 'ASC',
        //             properties: ['storeName']
        //           }
        //         })
        //           .then((res) => {
        //             this.listSearchStore =
        //               res.data.listData?.map((item) => ({
        //                 id: item.id,
        //                 text: item.storeName || item.email,
        //                 name: item.storeName || item.email
        //               })) || []
        //             success({ results: this.listSearchStore })
        //           })
        //           .catch(failure)
        //       }, 500)
        //     }
        //   }
        // }

        // headerStoreSettings: {
        //   ajax: {
        //     delay: 500,
        //     transport: (params, success, failure) => {
        //       const txtSearch = params.data?.q?.trim() || ''
        //       if (!txtSearch) {
        //         return success({ results: [] })
        //       }
        //       const queryString = `{textSearch} like '''${txtSearch}'''`

        //       // if (this.selectedStoreList.length > 0) {
        //       //   const excludeIds = this.selectedStoreList
        //       //     .map((store) => `'''${store.id}'''`)
        //       //     .join(" , ");
        //       //   queryString += ` and {id} nin [${excludeIds}]`;
        //       // }

        //       if (this.tLoadStore) {
        //         clearTimeout(this.tLoadStore)
        //       }
        //       this.tLoadStore = setTimeout(() => {
        //         ListStore({
        //           showFields: [
        //             'id',
        //             'storeName',
        //             'email',
        //             'merchantOwnerId',
        //             'merchantAccountId'
        //           ],
        //           limit: 10,
        //           page: 1,
        //           queryString,
        //           sort: {
        //             direction: 'ASC',
        //             properties: ['storeName']
        //           }
        //         })
        //           .then((res) => {
        //             this.listSearchStore =
        //               res.data.listData?.map((item) => ({
        //                 ...item,
        //                 id: item.id,
        //                 text: item.storeName || item.email,
        //                 name: item.storeName || item.email,
        //                 merchantOwnerId: item.merchantOwnerId,
        //                 merchantAccountId: item.merchantAccountId
        //               })) || []
        //             success({ results: this.listSearchStore })
        //           })
        //           .catch(failure)
        //       }, 500)
        //     }
        //   }
        // }
      }
    },
    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    // created() {
    //   const encodedData = this.$route.query.data
    //   const is_ids = this.$route.query.ids

    //   if (encodedData) {
    //     const compressed = Uint8Array.from(atob(encodedData), (c) =>
    //       c.charCodeAt(0)
    //     )
    //     const decompressed = gzip.unzip(compressed)
    //     const sOptions = String.fromCharCode(...decompressed)
    //     const optionsObject = JSON.parse(sOptions)
    //     this.query = optionsObject.query
    //   } else {
    //     if (is_ids) {
    //       showMess(
    //         this,
    //         'Thông báo',
    //         'Không có thông tin đối tượng cần gán',
    //         'danger',
    //         'b-toaster-top-right',
    //         5 * 60 * 60
    //       )
    //     }
    //   }

    //   // if (this.hasAssignPermission) {
    //   //   this.fields.unshift({
    //   //     key: 'checkbox',
    //   //     label: '',
    //   //     sortable: false,
    //   //     thStyle: 'width: 30px; text-align: center'
    //   //   })
    //   // }
    // },

    async mounted() {
      // await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_MA_LIST')) {
        await this.loadDataType()
        await this.getListStaffBySuperior()

        // if (this.query) return

        const encodedData = this.$route.query.ids

        // const encodedDataAll = this.$route.query.data

        // await this.loadData()

        if (encodedData) {
          const compressed = Uint8Array.from(atob(encodedData), c => c.charCodeAt(0))
          const decompressed = gzip.unzip(compressed)
          const sIds = String.fromCharCode(...decompressed)
          this.ids = sIds.split(/,/g)
          if (!this.ids || this.ids.length === 0)
            return showMess(
              this,
              'Thông báo',
              'Không có đối tượng để gán',
              'danger',
              'b-toaster-top-right',
              5 * 60 * 60
            )
          await this.loadData()
        } else {
          showMess(
            this,
            'Thông báo',
            'Không có thông tin đối tượng cần gán',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      total() {
        return this.pagination.total - this.deleteds.length
      },

      // Computed cho form điều khiển
      isUpdateAndIsSuperior() {
        return this.id && this.id !== NEW_ID && this.isSuperior
      },

      disabledStaff() {
        return (
          !this.applyFor ||
          (this.applyFor === EnumTaskApplyFor.MO
            ? !this.merchantOwnerId
            : this.applyFor === EnumTaskApplyFor.MA
              ? !this.customerId
              : !this.storeId) ||
          !this.staffOptions.length
        )
      },

      hasAssignPermission() {
        return this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_CREATE')
      },

      // Computed cho select rows
      hasCheckeds() {
        return this.idsSelected.length > 0
      },
    },

    methods: {
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.createTaskState === 'FAILED') return 'table-danger'
      },
      async getListStaffBySuperior() {
        console.log('aaa')
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            this.dataStaff =
              data.data.map(e => ({
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              })) || []
          }
          this.dataStaff.unshift({ id: '0', text: 'Tất cả' })
        } catch (error) {}
      },
      // Thêm method xóa các item chưa có người xử lý
      async removeItemsWithoutAssignee() {
        try {
          // Đếm số lượng item không có người xử lý
          const itemsWithoutAssignee = this.dataTable.filter(item => !item.assigneeId)

          if (!itemsWithoutAssignee.length) {
            return showMess(
              this,
              'Thông báo',
              'Không có Merchant nào thiếu người xử lý',
              'info',
              'b-toaster-top-right'
            )
          }

          // Hiển thị confirm dialog
          const result = await this.$bvModal.msgBoxConfirm(
            `Bạn có chắc chắn muốn xóa ${itemsWithoutAssignee.length} Merchant chưa có người xử lý?`,
            {
              title: 'Xác nhận xóa',
              okTitle: 'Đồng ý',
              cancelTitle: 'Hủy',
              okVariant: 'danger',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true,
            }
          )

          if (!result) return

          // Lọc bỏ các items không có người xử lý
          this.dataTable = this.dataTable.filter(item => item.assigneeId)

          // Reset chọn tất cả nếu đang bật
          if (this.selectAll) {
            this.selectAll = false
          }

          // Cập nhật lại danh sách items được chọn
          this.idsSelected = this.idsSelected.filter(id =>
            this.dataTable.some(item => item.id === id)
          )

          showMess(
            this,
            'Thông báo',
            `Đã xóa ${itemsWithoutAssignee.length} Merchant khỏi danh sách`,
            'success',
            'b-toaster-top-right'
          )
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right'
          )
        }
      },
      // Methods cho việc load dữ liệu

      removeItem(item, index) {
        this.$bvModal
          .msgBoxConfirm('Bạn có chắc chắn muốn xóa item này?', {
            title: 'Xác nhận xóa',
            okVariant: 'danger',
            okTitle: 'Xóa',
            cancelTitle: 'Hủy',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              // Xóa item khỏi dataTable
              this.dataTable.splice(index, 1)

              // Xóa ID khỏi danh sách ids
              const idIndex = this.ids.indexOf(item.id)
              if (idIndex > -1) {
                this.ids.splice(idIndex, 1)
              }

              // Cập nhật totalCount
              this.totalCount = this.dataTable.length

              showMess(this, 'Thông báo', 'Xóa thành công', 'success', 'b-toaster-top-right')
            }
          })
      },

      // async configSystem() {
      //   try {
      //     const data = await CommonService.getConfigSystem()
      //     if (data.success) {
      //       console.log('config', data.data)
      //     }
      //   } catch (error) {
      //     console.error(error)
      //   }
      // },

      async loadDataType() {
        try {
          const res = await WorkGroupList({
            size: 100,
            page: 1,
            status: 'APPLYING',
            showTasks: true,
          })
          if (res.result) {
            // Tạo map tasks theo type
            this.typeTasksMap = res.data.reduce((map, group) => {
              map[group.id] = group.wkTaskResList.map(task => ({
                id: task.id,
                text: task.taskName,
                code: task.taskCode,
              }))
              return map
            }, {})

            // Set typeOptions như cũ
            this.typeOptions = res.data.map(item => {
              return {
                id: item.id,
                text: item.groupName,
                code: item.groupCode,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },

      // Sửa lại hàm loadHeaderPurposes để dùng từ map
      async loadHeaderPurposes() {
        try {
          this.headerFilterLoading.purposes = true
          this.headerFilter.purposes = ''
          this.headerFilterOptions.purposes = this.typeTasksMap[this.headerFilter.type] || []
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right'
          )
        } finally {
          this.headerFilterLoading.purposes = false
        }
      },

      // Sửa lại hàm loadItemPurposes để dùng từ map
      async loadItemPurposes(item) {
        if (!item.purposesOptions || !item.purposesOptions.length) {
          try {
            item.loadingPurposes = true
            item.purposesOptions = this.typeTasksMap[item.type] || []
          } catch (e) {
            showMess(
              this,
              'Error',
              e.response?.data?.message || e.response?.message || e.message,
              'danger',
              'b-toaster-top-right'
            )
          } finally {
            item.loadingPurposes = false
          }
        }
      },

      // async loadDataTask() {
      //   try {
      //     this.isLoadingPurposes = true
      //     this.purposes = ''
      //     this.purposesOptions = []
      //     const res = await WorkTaskList({
      //       size: 100,
      //       page: 1,
      //       status: 'APPLYING',
      //       wkGroupId: this.type
      //     })
      //     if (res.result) {
      //       this.purposesOptions = res.data.map((item) => {
      //         return {
      //           id: item.id,
      //           text: item.taskName,
      //           code: item.taskCode
      //         }
      //       })
      //     } else {
      //       showMess(
      //         this,
      //         'Error',
      //         res.message,
      //         'danger',
      //         'b-toaster-top-right',
      //         5 * 60 * 60
      //       )
      //     }
      //   } catch (e) {
      //     showMess(
      //       this,
      //       'Error',
      //       e.response?.data?.message || e.response?.message || e.message,
      //       'danger',
      //       'b-toaster-top-right',
      //       5 * 60 * 60
      //     )
      //   } finally {
      //     this.isLoadingPurposes = false
      //   }
      // },

      // async loadDataStore() {
      //   try {
      //     this.isLoadingStore = true
      //     this.storeId = ''
      //     this.storeOptions = []
      //     const res = await ListStore({
      //       size: 100,
      //       page: 1,
      //       queryString: `{mcAccountId} == '''${this.customerId}'''`
      //     })
      //     if (res.result) {
      //       this.storeOptions = res.data.listData.map((item) => ({
      //         id: item.id,
      //         text: item.storeName
      //       }))
      //     } else {
      //       showMess(
      //         this,
      //         'Error',
      //         res.message,
      //         'danger',
      //         'b-toaster-top-right',
      //         5 * 60 * 60
      //       )
      //     }
      //   } catch (e) {
      //     showMess(
      //       this,
      //       'Error',
      //       e.response?.data?.message || e.message,
      //       'danger',
      //       'b-toaster-top-right',
      //       5 * 60 * 60
      //     )
      //   } finally {
      //     this.isLoadingStore = false
      //   }
      // },

      // async loadStaffAssign(id, level) {
      //   try {
      //     this.isLoadingStaff = true
      //     const res = await GetAssignment({
      //       assignmentIds: [id],
      //       level: level
      //     })
      //     if (res.result && res.data?.length) {
      //       const list = []
      //       for (const assignInfo of res.data) {
      //         if (assignInfo.staffMain) {
      //           list.push({
      //             id: assignInfo.staffMain.staffId,
      //             text: assignInfo.staffMain.staffName
      //           })
      //         }
      //         if (assignInfo.staffSeconds?.length) {
      //           for (const staff of assignInfo.staffSeconds) {
      //             if (staff.staffId && staff.staffName) {
      //               list.push({
      //                 id: staff.staffId,
      //                 text: staff.staffName
      //               })
      //             }
      //           }
      //         }
      //       }
      //       this.staffOptions = list
      //     } else {
      //       showMess(
      //         this,
      //         'Error',
      //         res.message,
      //         'danger',
      //         'b-toaster-top-right',
      //         5 * 60 * 60
      //       )
      //     }
      //   } catch (e) {
      //     showMess(
      //       this,
      //       'Error',
      //       e.message,
      //       'danger',
      //       'b-toaster-top-right',
      //       5 * 60 * 60
      //     )
      //   } finally {
      //     this.isLoadingStaff = false
      //   }
      // },

      // Methods cho table và phân trang

      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true

          // // get ids customer
          // const resCustomerIds = await ExecSqlGetOnlyIds({
          //   page: this.pagination.page,
          //   limit: this.pagination.limit,
          //   req: this.query
          // })

          // if (resCustomerIds?.code !== 1000) {
          //   return showMess(
          //     this,
          //     'Thông báo',
          //     resCustomerIds.message,
          //     'danger',
          //     'b-toaster-top-right',
          //     5 * 60 * 60
          //   )
          // }

          // const customerIds =
          //   resCustomerIds.data?.content?.reduce((arr, item) => {
          //     arr.push(item.merchantIdMyNP)
          //     return arr
          //   }, []) || []

          // this.pagination.total = resCustomerIds.data?.totalElements || 0

          // if (customerIds?.length === 0) {
          //   return showMess(
          //     this,
          //     'Thông báo',
          //     'Không có dữ liệu',
          //     'danger',
          //     'b-toaster-top-right',
          //     5 * 60 * 60
          //   )
          // }

          // const resConvertIds = await GetIdsByCustomerIds(customerIds)

          // if (resConvertIds.code !== 1000) {
          //   return showMess(
          //     this,
          //     'Thông báo',
          //     resConvertIds.message,
          //     'danger',
          //     'b-toaster-top-right',
          //     5 * 60 * 60
          //   )
          // }

          // const maIds = Object.values(resConvertIds.data).filter(
          //   (id) => !this.deleteds.includes(id)
          // )

          // if (maIds.length === 0) {
          //   return showMess(
          //     this,
          //     'Thông báo',
          //     'Không có dữ liệu merchant account',
          //     'danger',
          //     'b-toaster-top-right',
          //     5 * 60 * 60
          //   )
          // }

          //
          const searchQuery = {
            countStatus: true,
            showStaffAssign: true,
            // limit: this.pagination.limit,
            // page: this.pagination.page,
            limit: this.ids.length,
            page: 1,
            queryString: `{id} IN ['''${this.ids.join("''', '''")}''']`,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }

          // Gọi API GetAssignment để lấy thông tin staff
          const resAssignment = await GetAssignment({
            assignmentIds: this.ids,
            level: 'MERCHANT_ACCOUNT',
          })

          // Tạo map để dễ dàng truy cập thông tin staff theo assignmentId
          const mapStaffAssign = resAssignment.data.reduce((map, item) => {
            map[item.assignmentId] = item
            return map
          }, {})

          const res = await Search(searchQuery)

          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              // Lấy thông tin staff từ map theo id của item
              const staffAssignment = mapStaffAssign[el.id]

              // Xây dựng danh sách options cho staff
              const staffOptions = []

              // Thêm staff chính vào options
              if (staffAssignment?.staffMain) {
                staffOptions.push({
                  id: staffAssignment.staffMain.staffId,
                  text: staffAssignment.staffMain.staffName || staffAssignment.staffMain.staffEmail,
                })
              }

              // Thêm staff phụ vào options nếu có
              if (staffAssignment?.staffSeconds?.length) {
                staffAssignment.staffSeconds.forEach(staff => {
                  staffOptions.push({
                    id: staff.staffId,
                    text: staff.staffName || staff.staffEmail,
                  })
                })
              }

              return {
                ...el,
                purposesOptions: [],
                storeOptions: [],
                staffOptions: staffOptions,
                methodCare: EnumTaskMethodCare.OFFLINE,
                assigneeId:
                  staffAssignment?.staffMain?.staffId ||
                  staffAssignment?.staffSeconds[0]?.staffId ||
                  staffAssignment?.staffMain[0]?.staffId ||
                  '',
                dateRange: {
                  startDate: null,
                  endDate: null,
                },

                loadingPurposes: false,
                loadingStore: false,
                loadingStaff: false,
              }
            })
          } else {
            this.dataTable = []
          }

          this.pagination.total = res.data.totalCount ?? 0
          this.totalCount = res.data.totalCount ?? 0
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right'
          )
        } finally {
          this.isLoading = false
        }
      },

      onItemsPerPageChange() {
        this.pagination.page = 1
        this.loadData()
      },

      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.loadData()
      },

      // Methods cho việc select rows
      // toggleSelectAll() {
      //   const value = this.selectAll
      //   for (const item of this.dataTable) {
      //     item.checked = value
      //     const id = item.id
      //     const index = this.idsSelected.indexOf(id)
      //     index >= 0 && this.idsSelected.splice(index, 1)
      //     if (value) {
      //       !this.idsSelected.includes(id) && this.idsSelected.push(id)
      //     }
      //   }
      //   this.cleanSelectIfOver()
      // },

      // toggleSelectOne(item) {
      //   const id = item.id
      //   const index = this.idsSelected.indexOf(id)
      //   index >= 0 && this.idsSelected.splice(index, 1)
      //   if (item.checked) {
      //     !this.idsSelected.includes(id) && this.idsSelected.push(id)
      //   }
      //   this.selectAll = this.dataTable.every((item) => item.checked)
      //   this.cleanSelectIfOver()
      // },

      onClearSelect() {
        this.idsSelected = []
        this.selectAll && (this.selectAll = false)
        this.dataTable.forEach(item => {
          item.checked && (item.checked = false)
        })
      },

      cleanSelectIfOver() {
        if (this.idsSelected.length > this.maxtSelect) {
          this.idsSelected = this.idsSelected.slice(-this.maxtSelect)
        }
      },

      // Lấy thông tin từ bộ lọc
      getFilterData() {
        return {
          type: this.type,
          purposes: this.purposes,
          applyFor: this.applyFor,
          methodCare: this.methodCare,
          merchantOwnerId: this.merchantOwnerId,
          storeId: this.storeId,
          assigneeId: this.assigneeId,
        }
      },

      //
      // async loadHeaderPurposes() {
      //   try {
      //     this.headerFilterLoading.purposes = true
      //     this.headerFilter.purposes = ''
      //     this.headerFilterOptions.purposes = []

      //     const res = await WorkTaskList({
      //       size: 100,
      //       page: 1,
      //       status: 'APPLYING',
      //       wkGroupId: this.headerFilter.type
      //     })

      //     if (res.result) {
      //       this.headerFilterOptions.purposes = res.data.map((item) => ({
      //         id: item.id,
      //         text: item.taskName,
      //         code: item.taskCode
      //       }))
      //     }
      //   } catch (e) {
      //     showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right')
      //   } finally {
      //     this.headerFilterLoading.purposes = false
      //   }
      // },
      // Bỏ gán
      // async unassign() {
      //   try {
      //     this.isLoading = true

      //     // Nếu không có items được chọn thì bỏ gán tất cả
      //     if (!this.idsSelected.length) {
      //       this.dataTable = this.dataTable.map((item) => ({
      //         ...item,
      //         type: '',
      //         purposes: '',
      //         applyFor: '',
      //         methodCare: EnumTaskMethodCare.OFFLINE,
      //         merchantOwnerId: '',
      //         storeId: '',
      //         assigneeId: ''
      //       }))

      //       // showMess(
      //       //   this,
      //       //   'Thông báo',
      //       //   'Đã bỏ gán tất cả items',
      //       //   'success',
      //       //   'b-toaster-top-right'
      //       // )
      //       return
      //     }

      //     // Nếu có items được chọn thì chỉ bỏ gán các items đó
      //     this.dataTable = this.dataTable.map((item) => {
      //       if (this.idsSelected.includes(item.id)) {
      //         return {
      //           ...item,
      //           type: '',
      //           purposes: '',
      //           applyFor: '',
      //           methodCare: EnumTaskMethodCare.OFFLINE,
      //           merchantOwnerId: '',
      //           storeId: '',
      //           assigneeId: ''
      //         }
      //       }
      //       return item
      //     })

      //     showMess(
      //       this,
      //       'Thông báo',
      //       'Đã bỏ gán các items được chọn',
      //       'success',
      //       'b-toaster-top-right'
      //     )
      //   } catch (error) {
      //     showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right')
      //   } finally {
      //     this.isLoading = false
      //   }
      // },
      // Thêm method mới vào phần methods:

      // Reset bộ lọc header
      resetFilter() {
        // Reset filter values
        this.headerFilter = {
          type: '',
          purposes: '',
          applyFor: '',
          methodCare: this.EnumTaskMethodCare.OFFLINE,
          merchantOwnerId: '',
          storeId: '',
          assigneeId: JSON.parse(localStorage.getItem('userData')).userId,
        }

        // Reset options
        this.headerFilterOptions = {
          purposes: [],
          merchantOwner: [],
          store: [],
          staff: [
            {
              id: JSON.parse(localStorage.getItem('userData')).userId,
              text: JSON.parse(localStorage.getItem('userData')).name,
            },
          ],
        }
      },

      async assignAll() {
        try {
          // Validate dữ liệu bắt buộc từ headerFilter
          if (!this.headerFilter.type || !this.headerFilter.purposes) {
            return showMess(
              this,
              'Thông báo',
              'Vui lòng chọn đầy đủ thông tin nhóm công việc và tên công việc',
              'warning',
              'b-toaster-top-right'
            )
          }
          // Reset trạng thái lỗi trước khi submit
          this.dataTable = this.dataTable.map(item => ({
            ...item,
            createTaskState: null,
            errorMessage: '',
            _showDetails: false,
          }))

          // Cập nhật tất cả items trong table với giá trị từ headerFilter
          this.dataTable = this.dataTable.map(item => {
            // Lấy danh sách purposes từ typeTasksMap cho type được chọn
            const purposesOptions = this.typeTasksMap[this.headerFilter.type] || []

            return {
              ...item,
              type: this.headerFilter.type,
              purposes: this.headerFilter.purposes,
              methodCare: this.headerFilter.methodCare,
              purposesOptions: purposesOptions,
              note: this.headerFilter.note,
              description: this.headerFilter.description,
              dateRange: this.headerFilter.dateRange,
              // Copy store options từ header nếu có store được chọn
              // assigneeId: item.assigneeId || '',
              assigneeId:
                this.headerFilter.assigneeId && this.headerFilter.assigneeId !== '0'
                  ? this.headerFilter.assigneeId
                  : item.assigneeId || '',
              // staffOptions: item.staffOptions || []
              staffOptions:
                this.headerFilter.assigneeId && this.headerFilter.assigneeId !== '0'
                  ? this.dataStaff
                  : item.staffOptions || [],

              // storeOptions:
              //   this.headerFilter.storeId && this.listSearchStore?.length
              //     ? [
              //         this.listSearchStore.find(
              //           (store) => store.id === this.headerFilter.storeId
              //         )
              //       ]
              //         .filter(Boolean)
              //         .map((store) => ({
              //           id: store.id,
              //           text: store.text || store.name,
              //           name: store.name,
              //           merchantOwnerId: store.merchantOwnerId,
              //           merchantAccountId: store.merchantAccountId
              //         }))
              //     : [],
            }
          })

          showMess(
            this,
            'Thông báo',
            'Đã áp dụng toàn bộ cho các merchant',
            'success',
            'b-toaster-top-right'
          )
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right'
          )
        }
      },

      // async assignSelected() {
      //   try {
      //     this.isLoading = true

      //     // Validate dữ liệu bắt buộc từ headerFilter
      //     if (
      //       !this.headerFilter.type ||
      //       !this.headerFilter.purposes
      //       // !this.headerFilter.applyFor
      //     ) {
      //       return showMess(
      //         this,
      //         'Thông báo',
      //         'Vui lòng chọn đầy đủ thông tin nhóm công việc, tên công việc và đối tượng',
      //         'warning',
      //         'b-toaster-top-right'
      //       )
      //     }

      //     // Cập nhật các items được chọn với giá trị từ headerFilter
      //     this.dataTable = await Promise.all(
      //       this.dataTable.map(async (item) => {
      //         if (this.idsSelected.includes(item.id)) {
      //           const updatedItem = {
      //             ...item,
      //             ...this.headerFilter
      //           }

      //           // Load purposes options nếu có type
      //           if (this.headerFilter.type) {
      //             const res = await WorkTaskList({
      //               size: 100,
      //               page: 1,
      //               status: 'APPLYING',
      //               wkGroupId: this.headerFilter.type
      //             })
      //             if (res.result) {
      //               updatedItem.purposesOptions = res.data.map((purpose) => ({
      //                 id: purpose.id,
      //                 text: purpose.taskName,
      //                 code: purpose.taskCode
      //               }))
      //             }
      //           }

      //           // Copy store options từ header nếu có store được chọn
      //           if (this.headerFilter.storeId && this.listSearchStore?.length) {
      //             const selectedStore = this.listSearchStore.find(
      //               (store) => store.id === this.headerFilter.storeId
      //             )
      //             if (selectedStore) {
      //               if (!updatedItem.storeOptions) {
      //                 updatedItem.storeOptions = []
      //               }
      //               updatedItem.storeOptions = [
      //                 {
      //                   id: selectedStore.id,
      //                   text: selectedStore.text || selectedStore.name,
      //                   name: selectedStore.name,
      //                   merchantOwnerId: selectedStore.merchantOwnerId,
      //                   merchantAccountId: selectedStore.merchantAccountId
      //                 }
      //               ]
      //             }
      //           }

      //           // Copy staff options từ headerFilterOptions
      //           updatedItem.staffOptions = [...this.headerFilterOptions.staff]

      //           return updatedItem
      //         }
      //         return item
      //       })
      //     )
      //   } catch (error) {
      //     showMess(this, 'Error', error.message, 'danger', 'b-toaster-top-right')
      //   } finally {
      //     this.isLoading = false
      //   }
      // },

      onOpeningItemStoreSelect(item) {
        // Truyền mcAccountId vào settings của select2
        if (this.itemStoreSettings.ajax) {
          const originalTransport = this.itemStoreSettings.ajax.transport
          this.itemStoreSettings.ajax.transport = (params, success, failure) => {
            // Thêm mcAccountId vào params
            params.data = {
              ...params.data,
              mcAccountId: item.customerId, // hoặc item.mcAccountId tùy theo tên field trong data
            }
            return originalTransport(params, success, failure)
          }
        }
      },
      // Tạo settings động cho mỗi item
      getItemStoreSettings(mcAccountId) {
        return {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({ results: [] })
              }

              let queryString = `{textSearch} like '''${txtSearch}'''`

              // Sử dụng mcAccountId được truyền vào
              if (mcAccountId) {
                queryString += ` and {mcAccountId} == '''${mcAccountId}'''`
              }

              if (this.tLoadStore) {
                clearTimeout(this.tLoadStore)
              }
              this.tLoadStore = setTimeout(() => {
                ListStore({
                  showFields: ['id', 'storeName', 'email', 'merchantOwnerId', 'merchantAccountId'],
                  limit: 10,
                  page: 1,
                  queryString,
                  sort: {
                    direction: 'ASC',
                    properties: ['storeName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.listData?.map(item => ({
                          ...item,
                          id: item.id,
                          text: item.storeName || item.email,
                          name: item.storeName || item.email,
                          merchantOwnerId: item.merchantOwnerId,
                          merchantAccountId: item.merchantAccountId,
                        })) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        }
      },

      // Validate data trước khi submit
      validateItemFields(item) {
        const errors = []

        if (!item.type) errors.push('Thiếu nhóm công việc')
        if (!item.purposes) errors.push('Thiếu tên công việc')
        // if (!item.applyFor) errors.push('Thiếu đối tượng')
        if (!item.assigneeId) errors.push('Thiếu người xử lý')

        return errors
      },

      //  hàm formatTaskData
      formatTaskData(item) {
        const selectedType = this.typeOptions?.find(t => t.id === item.type)
        const selectedPurpose = item.purposesOptions?.find(p => p.id === item.purposes)

        return {
          customerId: item.id || '',
          saleId: item.assigneeId || '',
          type: selectedType?.code || '',
          purposes: selectedPurpose?.code ? [selectedPurpose.code] : [],
          note: item.note || '',
          description: item.description || '',
          startIntend: new Date(item?.dateRange?.startDate).getTime() || 0,
          endIntend: new Date(item?.dateRange?.endDate).getTime() || 0,
        }
      },

      // hàm submitForm
      async submitForm() {
        try {
          this.isLoadingSubmit = true

          // Kiểm tra tất cả các trường bắt buộc
          let hasInvalidItems = false
          this.dataTable = this.dataTable.map(item => {
            const errors = this.validateItemFields(item)

            if (errors.length > 0) {
              hasInvalidItems = true
              return {
                ...item,
                createTaskState: 'FAILED',
                errorMessage: errors.join(', '),
                _showDetails: true,
              }
            }
            return {
              ...item,
              createTaskState: null,
              errorMessage: '',
              _showDetails: false,
            }
          })

          if (hasInvalidItems) {
            return showMess(
              this,
              'Thông báo',
              'Có item thiếu thông tin, vui lòng kiểm tra các item được đánh dấu đỏ',
              'warning',
              'b-toaster-top-right'
            )
          }

          // Reset trạng thái lỗi trước khi submit
          this.dataTable = this.dataTable.map(item => ({
            ...item,
            createTaskState: null,
            errorMessage: '',
            _showDetails: false,
          }))

          // Validate items
          const validItems = this.dataTable.filter(
            item => item.type && item.purposes && item.assigneeId && item.customerId
          )

          if (!validItems.length) {
            return showMess(
              this,
              'Thông báo',
              'Không có công việc nào được cấu hình đầy đủ',
              'warning',
              'b-toaster-top-right'
            )
          }

          // Validate chi tiết từng item
          // for (const item of validItems) {
          //   const error = this.validateItemData(item)
          //   if (error) {
          //     return showMess(
          //       this,
          //       'Thông báo',
          //       error,
          //       'warning',
          //       'b-toaster-top-right'
          //     )
          //   }
          // }

          // Format data và gọi API
          const taskRequests = validItems.map(item => this.formatTaskData(item))

          const result = await TaskAddAll(taskRequests)

          if (result.result) {
            // Cập nhật trạng thái trong table
            this.dataTable = this.dataTable.map(item => {
              const resultItem = result.data.find(r => r.customerId === item.id)
              if (resultItem) {
                return {
                  ...item,
                  createTaskState: resultItem.createTaskState,
                  errorMessage: resultItem.errorMessage,
                  _showDetails: resultItem.createTaskState === 'FAILED',
                }
              }
              return item
            })

            // Thống kê kết quả
            const successCount = result.data.filter(r => r.createTaskState === 'SUCCESS').length
            const failedCount = result.data.filter(r => r.createTaskState === 'FAILED').length

            if (failedCount > 0) {
              showMess(
                this,
                'Thông báo',
                `Tạo thành công ${successCount} công việc, thất bại ${failedCount} công việc. Chi tiết xem trong danh sách đã đánh dấu đỏ.`,
                'warning',
                'b-toaster-top-right'
              )
            } else {
              this.showSuccessMx('Tạo thành công tất cả công việc').then(() => {
                this.$router.push('/customer-support/task/')
              })
            }
          } else {
            showMess(
              this,
              'Thông báo',
              result.message || 'Có lỗi xảy ra',
              'error',
              'b-toaster-top-right'
            )
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right'
          )
        } finally {
          this.isLoadingSubmit = false
        }
      },
    },
  }
</script>
<style scoped lang="scss">
  .h3 {
    font-size: 16px;
    // text-transform: uppercase;
    margin-bottom: 15px !important;
    font-weight: normal !important;
  }

  .list-help {
    // border: 1px solid #dcdcdc;
    // border-radius: 12px;
    // padding: 12px;
    margin-right: 10px;
    h3 {
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 15px !important;
      font-weight: normal !important;
    }
    label {
      font-weight: 600;
    }

    ul {
      margin-left: 15px;
      margin-bottom: 17px;

      li {
        font-size: 12px;
        list-style: disc;

        label {
          font-weight: 600;
        }
      }
    }
  }

  .table-danger {
    background-color: rgba(255, 0, 0, 0.1) !important;

    &:hover {
      background-color: rgba(255, 0, 0, 0.2) !important;
    }
  }

  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  .nowrap {
    white-space: nowrap;
  }

  .form-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;

      &:first-child {
        margin-top: 0;
      }

      .form-label {
        font-weight: 400;
        font-size: 14px;
        color: #2a2a2a;

        &.require::after {
          content: '*';
          color: #f00;
          margin-left: 4px;
        }
      }

      .form-input {
        width: 60%;

        .error {
          color: #f00;
        }
      }
    }
  }
</style>
